import styled, { css } from "styled-components";

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const FormLabel = styled.label`
  color: var(--zyvgo-text-primary, #344054);
  font-size: 0.75rem;
  font-weight: 650;
  letter-spacing: 0.01em;
  margin-bottom: 6px;
`;

export const secureFieldCss = css`
  background: var(--zyvgo-card-bg, #fff);
  border: 1px solid var(--zyvgo-border, #d0d5dd);
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
  color: var(--zyvgo-text-primary, #101828);
  min-height: 46px;
  transition:
    border-color 0.16s ease,
    box-shadow 0.16s ease,
    background-color 0.16s ease;

  &:hover {
    border-color: #98a2b3;
  }

  &:focus,
  &:focus-within {
    background: #fff;
    border-color: var(--zyvgo-focus-border, #0f766e);
    box-shadow: 0 0 0 3px rgba(15, 118, 110, 0.12);
    outline: none;
  }
`;

export const FormInput = styled.input`
  ${secureFieldCss}
  padding: 11px 13px;
  width: 100%;
  font-size: 0.9375rem;
  line-height: 1.4;

  &::placeholder {
    color: var(--zyvgo-text-placeholder, #98a2b3);
    opacity: 1;
  }

  &:invalid:not(:placeholder-shown) {
    border-color: var(--zyvgo-error, #d92d20);
  }

  @media (max-width: 599px) {
    font-size: 1rem;
  }
`;

export const EmbeddedField = styled.div`
  ${secureFieldCss}
  align-items: center;
  display: flex;
  overflow: hidden;
  padding: 11px 13px;
  position: relative;
  width: 100%;
`;

export const FormRow = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  @media (max-width: 420px) {
    grid-template-columns: 1fr;
  }
`;

export const FormColumn = styled.div`
  min-width: 0;
`;

export const LoadingText = styled.div`
  color: var(--zyvgo-text-secondary, #667085);
  font-size: 0.75rem;
`;

export const ErrorText = styled.div`
  background: #fff1f2;
  border: 1px solid #fecdd3;
  border-radius: 7px;
  color: var(--zyvgo-error, #b42318);
  font-size: 0.75rem;
  line-height: 1.45;
  padding: 9px 10px;
`;
